import React from 'react';
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import UseContext from "hooks/useContext";
import {CardIdentity} from "../../../../assets/icons";

const IdentityValidationDL = () => {
    const {language} = UseContext()
    return (
        <SidebarUnitDesktop 
            routeName={"Validation d'identité"} 
            routeSidebar={"/identity_validation"}
            icon={CardIdentity}
            text={language.getValue('sidebar.identity_validation','Validation d\'identité')}
            exactMatch={true}
        />
    );
};

export default IdentityValidationDL;